import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { TotalBarWithDccView } from '@mews-distributor/ui';
import { getCurrencyCode } from '../../../modules/app/selectors';
import {
    getFormattedSurchargeFees,
    hasSelectedEnterpriseSurcharge,
} from '../../../modules/paymentConfigurations/selectors';
import { hasSelectedEnterpriseNetPricing } from '../../../selectors/views/selectedEnterprise/selectedEnterprise';
import { ApplicationState } from '../../../types';
import {
    getReservationGroupTotalAmountInPaymentGatewayCurrency,
    getReservationsSimpleTotalAmount,
    isImmediatelySettledTotalAmountFullWithPreauthorizations,
    isImmediatelySettledTotalAmountPositiveWithPreauthorizations,
} from '../../../views/checkout/data/viewSelectors';
import { OrderRateGroupDescription } from '../TotalBar/OrderRateGroupDescription';

const renderOrderRateGroupDescription = () => <OrderRateGroupDescription />;

export const TotalBarWithDccContainer = connect<$TSFixMe, {}, $TSFixMe, ApplicationState>(
    createStructuredSelector({
        totalPrice: getReservationsSimpleTotalAmount,
        hasNetPricing: hasSelectedEnterpriseNetPricing,
        hasSurchargeService: hasSelectedEnterpriseSurcharge,
        surchargeFees: getFormattedSurchargeFees,
        renderRateGroupDescription: (state, { showRateGroupDescription }) =>
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            showRateGroupDescription ? renderOrderRateGroupDescription : null,
        selectedCurrency: getCurrencyCode,
        totalAmountInPaymentGatewayCurrency: getReservationGroupTotalAmountInPaymentGatewayCurrency,
        isImmediatelySettledTotalAmountPositive: isImmediatelySettledTotalAmountPositiveWithPreauthorizations,
        isImmediatelySettledTotalAmountFull: isImmediatelySettledTotalAmountFullWithPreauthorizations,
    })
)(TotalBarWithDccView);
